/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import InboxV3 from './InboxV3'
import {GetRmsChatList} from '../inbox-v2/InboxSlice/InboxSlice'
import {GetAllData as customNumberList} from '../accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {GetAllData as businessList} from '../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {getDedicatedNumberList} from '../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'

const InboxWrapper: FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    // Fetch initial data for inbox
    dispatch(GetRmsChatList())
    dispatch(getDedicatedNumberList({page: 1, size: 10}))
    dispatch(customNumberList())
    dispatch(businessList())
  }, [])

  return (
    <>
      <InboxV3 />
    </>
  )
}

export {InboxWrapper}
